import * as React from "react";
import { ChevronDown } from "~/components/icons/central-icons";

import { cn } from "~/lib/utils";
import { useShape } from "~/lib/shape-context";

type NativeSelectProps = Omit<React.ComponentProps<"select">, "size"> & {
  size?: "sm" | "default";
};

function NativeSelect({
  className,
  size = "default",
  ...props
}: NativeSelectProps) {
  const shape = useShape();

  return (
    <div
      className={cn(
        "group/native-select relative w-full has-[select:disabled]:opacity-50",
        className,
      )}
      data-slot="native-select-wrapper"
      data-size={size}
    >
      <select
        data-slot="native-select"
        data-size={size}
        className={cn(
          "control-surface h-11 w-full min-w-0 appearance-none rounded-3xl py-1 pr-9 pl-3.5 text-body text-foreground transition-[color,box-shadow,background-color] duration-80 outline-none select-none selection:bg-primary selection:text-primary-foreground placeholder:text-muted-foreground glider-focus-ring disabled:pointer-events-none disabled:cursor-not-allowed aria-invalid:ring-1 aria-invalid:ring-destructive/50 data-[size=sm]:h-9 data-[size=sm]:text-meta",
          shape.input,
        )}
        {...props}
      />
      <ChevronDown
        className="pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2 text-muted-foreground transition-colors select-none group-has-[select:focus-visible]/native-select:text-foreground"
        aria-hidden="true"
        data-slot="native-select-icon"
      />
    </div>
  );
}

function NativeSelectOption({ ...props }: React.ComponentProps<"option">) {
  return <option data-slot="native-select-option" {...props} />;
}

function NativeSelectOptGroup({
  className,
  ...props
}: React.ComponentProps<"optgroup">) {
  return (
    <optgroup
      data-slot="native-select-optgroup"
      className={cn(className)}
      {...props}
    />
  );
}

export { NativeSelect, NativeSelectOptGroup, NativeSelectOption };
